import { lifecycle, compose } from "recompose";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

const withLifeCycle = lifecycle({
  componentDidMount() {
    const {
      user,
      history: { replace }
    } = this.props;
    if (user) {
      replace("/contracts");
    }
  }
});

const mapStateToProps = state => ({ user: state.auth.user });

export default compose(
  connect(mapStateToProps),
  withRouter,
  withLifeCycle
);
